import React from 'react';
import { useSelector } from 'react-redux';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import { Preloader } from '../../shared/svg/components';

const ServerApiPopup = () => {
  const isSavingConfiguration = useSelector(state => state.configurator.isSavingConfiguration);
  const isDownloadingPdf = useSelector(state => state.configurator.isDownloadingPdf);
  const saveConfigurationMutation = SaveConfigurationService();

  let saveMessage = 'Guardando configuración...';

  if (isSavingConfiguration) {
    if (saveConfigurationMutation.isLoading) saveMessage = 'Loading...';
    if (saveConfigurationMutation.isError) saveMessage = 'Error saving configuration';

    return (
      <div className="overlay-background">
        <span>{saveMessage}</span>
      </div>
    );
  }

  if (isDownloadingPdf) {
    return (
      <div className="generate-pdf-overlay-background">
        <div className="container-loader">
          <Preloader className="icon" />
        </div>
        <div className="generate-pdf-title">Generando PDF...</div>
        <div className="generate-pdf-subtitle">Este proceso puede tardar unos segundos</div>
      </div>
    );
  }
  return null;
};

export default ServerApiPopup;
